import { render, staticRenderFns } from "./DetailsSectionReports.vue?vue&type=template&id=67d3aa1c&scoped=true&"
import script from "./DetailsSectionReports.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionReports.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSectionReports.vue?vue&type=style&index=0&id=67d3aa1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d3aa1c",
  null
  
)

export default component.exports